<script>
  import {getContext} from 'svelte';
  import {envUtil} from '@/helper/env';
  import {IMAGES} from '../images';
  import lang from '../HomePage.lang';

  const LG = getContext('LG');
  const width = envUtil.isMobile ? screen.width : 600;
  const background = envUtil.isMobile
    ? `background: url("${IMAGES.QUOTA}") no-repeat bottom 20px right 16px/48px 40px;`
    : `background: url("${IMAGES.QUOTA}") no-repeat bottom 54px right 54px/96px 80px;`;
  const pressList = [
    {
      text: LG(lang.BestCrypto),
      logo: IMAGES.PRESS_FORBES,
      alt: 'Forbes',
    },
    {
      text: LG(lang.FastestCrypto),
      logo: IMAGES.PRESS_NEW_YORK_POST,
      alt: 'New York Post',
    },
    {
      text: '“It includes everything you need for both beginners and professionals.”',
      logo: IMAGES.PRESS_BUSINESS,
      alt: 'Business Insider',
    },
    {
      text: '“Phemex maintains a simple, light, and blazing fast platform specifically designed for maximum uptime. Phemex has been silently climbing the ranks with the goal of becoming the top derivatives exchange in the world.”',
      logo: IMAGES.PRESS_IBT,
      alt: 'IBT',
    },
  ];

  let current = 0;

  function prePress() {
    if (current === 0) {
      return;
    }
    current += -1;
  }

  function nextPress() {
    if (current === pressList.length - 1) {
      return;
    }
    current += 1;
  }
</script>

<style>
  .wrap {
    padding: 120px 0;
    background: white;
  }
  .title {
    margin-top: 0;
    margin-bottom: 48px;
    text-align: center;
    font-size: 48px;
  }
  /* 这个180是初始的偏移量，随便定的 */
  .carousel {
    left: 180px;
    margin: 0 -10px;
    transition: transform 0.5s ease-in-out;
  }
  .carousel-item {
    box-sizing: border-box;
    padding: 0 10px;
  }
  .content {
    box-sizing: border-box;
    border-radius: 20px;
    padding: 60px 54px;
    height: 100%;
    font-size: 24px;
    box-shadow: 0 0 40px 0 rgba(0, 0, 0, 0.05);
  }
  .content img {
    height: 64px;
  }
  .content blockquote {
    margin: 0 0 36px 0;
    line-height: 36px;
    font-size: 24px;
  }
  .iconfont {
    border: 1px solid #333;
    border-radius: 50%;
    width: 80px;
    height: 80px;
    color: #333;
    cursor: pointer;
  }
  .iconfont.disabled {
    border-color: #ccc;
    color: #ccc;
    cursor: not-allowed;
  }
  .iconfont:first-child {
    margin-right: 48px;
    transform: rotate(90deg);
  }
  .iconfont:last-child {
    transform: rotate(-90deg);
  }
  @media screen and (max-width: 640px) {
    .wrap {
      padding: 40px 0;
    }
    .title {
      margin-bottom: 24px;
      padding: 0 20px;
      text-align: left;
      font-size: 18px;
    }
    .carousel {
      left: 0;
      margin: 0;
    }
    .carousel-item {
      padding: 0 20px;
    }
    .content {
      padding: 20px 16px;
      font-size: 14px;
    }
    .content blockquote {
      margin-bottom: 32px;
      line-height: 20px;
      font-size: 14px;
    }
    .content img {
      height: 40px;
    }
  }
</style>

<section class="wrap ovh">
  <h2 class="title">{LG(lang.WhatThePressSays)}</h2>
  <div class="carousel df ais pr" style="width: {width * pressList.length}px; transform: translateX(-{width * current}px)">
    {#each pressList as item}
      <div class="carousel-item" style="width: {width}px">
        <div class="content df fdc jcsb B3" style={background}>
          <blockquote>{item.text}</blockquote>
          <div>
            <div class="mb20 T3">{LG(lang.PublishOn)}</div>
            <img src={item.logo} alt={item.alt} />
          </div>
        </div>
      </div>
    {/each}
  </div>
  <div class="control df jcc mt40">
    <i class="iconfont df aic jcc f36" class:disabled={current === 0} on:click={prePress}>&#xe623;</i>
    <i class="iconfont df aic jcc f36" class:disabled={current === pressList.length - 1} on:click={nextPress}>&#xe623;</i>
  </div>
</section>
